import React, { useState } from "react";
import { PROMOTION_TOOLTIP } from "./constants";

const TOOLTIP_CLASSES = {
  left: "right-0 top-full mt-1",
  right: "left-full top-1/2 -translate-y-1/2 ml-1",
};

export function PromotionRatingLabel({ tooltipPosition = "left" }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const positionClass = TOOLTIP_CLASSES[tooltipPosition] ?? TOOLTIP_CLASSES.left;

  return (
    <span className="inline-flex items-center gap-1.5">
      <span>Promotion rating</span>
      <span
        className="relative inline-flex text-theme-text opacity-60 hover:opacity-100 cursor-help"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label={PROMOTION_TOOLTIP}
      >
        <svg
          className="w-4 h-4 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        {showTooltip && (
          <span
            className={`absolute ${positionClass} z-20 w-56 px-2 py-1.5 text-xs text-theme-text bg-theme-secondary border border-theme-secondary rounded shadow-lg pointer-events-none`}
            role="tooltip"
          >
            {PROMOTION_TOOLTIP}
          </span>
        )}
      </span>
    </span>
  );
}
